// extracted by mini-css-extract-plugin
module.exports = {"slide-one":"BannerSlider_slide-one__1mkoq","slide-two":"BannerSlider_slide-two__3c3bG","button-wrapper":"BannerSlider_button-wrapper__1joq1"};